
const digest = '09caa26b1908a97311fe9236799301e3f03256dfc527c0607c64a9b637b30b18';
const classes = {"container":"_container_it6k5_1"};
const css = `._container_it6k5_1 {
  padding: 16px;
  display: flex;
  gap: 12px;
  position: absolute;
  right: 0;
  bottom: 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  